// src/components/common/CategoryButton.jsx
import React from 'react';

const CategoryButton = ({ icon, text, isActive = false }) => (
  <div className={`flex flex-col items-center min-w-20 ${isActive ? 'text-green-600' : 'text-gray-600'}`}>
    <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-1 ${isActive ? 'bg-green-100' : 'bg-gray-100'}`}>
      {icon}
    </div>
    <p className="text-xs font-medium">{text}</p>
    {isActive && <div className="w-1 h-1 bg-green-600 rounded-full mt-1"></div>}
  </div>
);

export default CategoryButton;